import React from "react";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";

import { Container, ContainerInput, Content } from "./UserData.styles";
import {
  Header,
  Footer,
  InputUnform,
  Tooltip,
  Button,
  Modal,
  TextValidations,
  Terms,
  TemplateSendToken,
  InputTokensProps,
} from "../../../Components";

export type InputTypes =
  | "cpf"
  | "birthdate"
  | "cell_phone_number"
  | "username"
  | "password";

interface InputComponentProps {
  input: TextFieldProps;
  tooltip?: TooltipProps;
  value?: string;
}
export interface UserDataScreenProps {
  title: string;
  subtitle: string;
  inputs: Array<InputComponentProps>;

  formRef: React.RefObject<FormHandles>;
  countdownRef: any;
  handleSubmit(data: any): void;

  setInputToken(name: string, value: string): void;
  inputTokens: InputTokensProps;

  handleSendStepProposalToken(): void;

  showModal: boolean;
  closeModal(): void;

  loadingResendToken: boolean;
  handleResendToken(): void;

  loadingSendPassword: boolean;
  disabledSendPassword: boolean;
}

interface TextFieldProps {
  mask: string;
  labelText: string;
  placeholder: string;
  name: string;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
  disabled: boolean;
  focus?: boolean;
  handleFocus?(): void;
  onKeyPress?(event: React.KeyboardEvent<HTMLInputElement>): void;
  onBlur?(): void;
  maxLength?: number;
  // type?: "text" | "password";
}

interface TooltipProps {
  content: string;
  title: string;
}

export const UserDataScreen: React.FC<UserDataScreenProps> = ({
  title,
  subtitle,
  inputs,
  formRef,
  countdownRef,
  handleSubmit,
  inputTokens,
  setInputToken,
  handleSendStepProposalToken,
  showModal,
  closeModal,
  loadingResendToken,
  handleResendToken,
  loadingSendPassword,
  disabledSendPassword,
}) => {
  const handleFormSubmit = () => {};

  return (
    <Container>
      <Header />
      <Content>
        <h1>{title}</h1>
        <p>{subtitle}</p>

        <Form ref={formRef} onSubmit={handleFormSubmit}>
          {inputs?.map((input) => (
            <InputComponent {...input} />
          ))}
        </Form>

        <Terms type="descriptive" />

        <div className="centerButton">
          <Button
            disabled={disabledSendPassword}
            loading={loadingSendPassword}
            onClick={handleSubmit}
          >
            Continuar
          </Button>
        </div>
      </Content>
      <Footer />
      <Modal open={showModal} handleClose={closeModal}>
        <TemplateSendToken
          {...{
            setInputToken,
            inputTokens,
            countdownRef,
            handleResendToken,
            handleSendToken: handleSendStepProposalToken,
            loadingResendToken,
          }}
        />
      </Modal>
    </Container>
  );
};

const InputComponent: React.FC<InputComponentProps> = ({
  input,
  tooltip,
  value,
}) => {
  return (
    <ContainerInput>
      <InputUnform {...input} />

      {!!tooltip && (
        <div style={{ marginTop: 16 }}>
          <Tooltip content={tooltip.content} position="top">
            <div>{tooltip.title}</div>
          </Tooltip>
        </div>
      )}

      {input.name === "password" && (
        <div className="contianerValidation">
          <TextValidations
            {...{ value: value || "", disabled: input.disabled }}
          />
        </div>
      )}
    </ContainerInput>
  );
};
